import React, { useState, useEffect, Suspense, lazy } from "react";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import axios from "axios";
import LoadingBar from 'react-top-loading-bar'
import InfiniteScroll from "react-infinite-scroller";
import {Helmet} from "react-helmet";
import { ReactSession } from 'react-client-session';
import { Markup } from "interweave";

import './Videos.css';
import styles from "../../App.module.css";
import classes from "./Videos.module.css";
import Header from "../Header/Header";
// import Sidebar from "../Sidebar/Sidebar";
import Spinner from '../Global/Spinner';
import EmptyContent from "../Global/EmptyContent";

import noThumb from "../../images/no-thumb.jpg";
// import LoadMoreButton from "../Global/LoadMoreButton";
import Footer from "../Footer/Footer";
import Categories from "../Categories/Categories";

const Sidebar = lazy(() => import('../Sidebar/Sidebar'))

function Videos() {
  const [videos, setVideos] = useState([]);
  const [hasMore, sethasMore] = useState(true);
  const [page, setpage] = useState(2);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(10);
  const [tabIndex, setTabIndex] = useState(0);
  const [type, setType] = useState('algorithms');
  ReactSession.setStoreType("localStorage");

  let vids = ReactSession.get('vids') ? ReactSession.get('vids').toString() : '';

  useEffect(() => {
    try{
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }catch(ex){}
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.addEventListener('scroll', function(){
      setLoading(true);
    })
  },[]);

  useEffect(() => {
    if(tabIndex === 0) {
      setType('algorithms');
    }else if(tabIndex === 1) {
        setType('latest');
    }else if(tabIndex === 2) {
      setType('mostviewed');
    }else if(tabIndex === 3) {
      setType('mostliked');
    }else if(tabIndex === 4) {
      setType('featured');
    }

    setpage(2);
    setVideos([]);
  }, [tabIndex]);

  useEffect(() => {
    setProgress(20);
    type && axios.get(`${process.env.REACT_APP_API_URL}/api/videos.php?type=${type}&vids=${vids}&page=1&limit=12`)
      .then(response => {
        if(response.data.message !== 'No videos found') {
          setVideos(response.data);
          response.data.length < 12 ? sethasMore(false) : sethasMore(true);
        }else {
          sethasMore(false);
          setVideos([]);
        }

        // setLoading(true);
        setProgress(100);
      })
  }, [type]);

  const loadMore = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/videos.php?type=${type}&vids=${vids}&page=${page}&limit=12`)
    .then(response => {
      if(response.data.message !== 'No videos found') {
        loading && hasMore && setVideos([...videos, ...response.data]);
        setpage(page + 1);
        
        response.data.length < 12 ? sethasMore(false) : sethasMore(true);
      }else {
        sethasMore(false);
      }
    })
  };

  // const loadMore = () => {
  //   axios.get(`https://wesharez.com/api/videos.php?type=${type}&page=${page}&limit=12`)
  //   .then(response => {
  //     setVideos([...videos, ...response.data]);
  //     setpage(page + 1);

  //     response.data.length < 12 ? sethasMore(false) : sethasMore(true);
  //   })
  // }

  return (
    <>
      <Helmet>
        <title>Videos</title>
        <meta name="description" content="Share your web pages, articles, blog entries, photographs, and videos with friends, family, and the world on Wesharez." />
        <meta name="keywords" content="wesharez, youtube videos, musics, images, albums, earn money, Bookmarking, be a creator, share video, share your content, products, services, products and services, blog, latest articles, web pages, views, skin, science, days, review" />
      </Helmet>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Header />
      <div className={styles.main_body}>
        <Suspense fallback="<div>Please wait...</div>">
          <Sidebar active="videos" />
        </Suspense>
        <Suspense fallback="<div>Please wait...</div>">
          <div className={styles.main_content + ` main-content`}>
            <ins className='adsbygoogle p-4 pb-0'
              style={{ display: 'block' }}
              data-ad-client='ca-pub-8126596259429304'
              data-ad-slot='5153011292'
              data-ad-format='auto'
            />
            <Categories type="1" />
            <div className="videos-component p-4">
              <div className={classes.sec_name}>
                <h3>Videos</h3>
              </div>
              {/* <div className="sec-tabs mb-2">
                <ul className="d-inline">
                  <li>
                      <a href="/" className="active">Featured Videos</a>
                  </li>
                  <li><a href="/">New Videos</a></li>
                  <li><a href="/">Recommended For You</a></li>
                </ul>
              </div> */}
              <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index) }>
                <TabList>
                    <Tab>Algorithm</Tab>
                    <Tab>Recent</Tab>
                    <Tab>Top</Tab>
                    <Tab>Liked</Tab>
                    <Tab>Picks</Tab>
                </TabList>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
              </Tabs>
              <div className="videos">
                {
                  videos.length === 0 ? <EmptyContent /> : videos && videos.map &&  <InfiniteScroll
                    pageStart={0}
                    loadMore={loadMore}
                    hasMore={hasMore}
                    loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                    className="row m-0"
                  >
                    {
                      videos.map((video, index) => {
                        let thumb = null;
                        if(video.thumb.includes('storage/media/thumbs/')) {
                          thumb = `${process.env.REACT_APP_API_URL}/${video.thumb}`;
                        }else {
                          thumb = video.thumb;
                        }
                        return (
                          <div key={index} className={styles.videoitem + ` col-lg-3 col-sm-6`}>
                            <div className="video">
                              <div className={styles.video_thumb}>
                                  <Link className={styles.clip_link} to={`/video/${video.id}/${video.nice_url}`}>
                                    <img src={thumb} onError={e => {e.target.src = noThumb}} alt={video.title} />
                                  </Link>
                                  {
                                    (video.duration > 0) && <div className={styles.time}>{video.video_time}</div>
                                  }
                              </div>
                              <div className={styles.video_data}>
                                <div className={styles.video_title}>
                                    <Link to={`/video/${video.id}/${video.nice_url}`}><Markup content={video.title}></Markup></Link>
                                </div>
                                <div className={styles.stats}>
                                  <div className={styles.uploaderlink}>
                                    <Link to={`/profile/${video.user_id}/${video.username}`}>{video.name}</Link>
                                  </div>
                                  <ul className={styles.meta}>
                                      <li>{video.views} views</li>
                                      <li>·</li>
                                      <li>{video.time_ago}</li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                  </InfiniteScroll>
                }
                {/* <div className="row m-0">
                </div> */}
              </div>
              {/* <div className="pt-5 mb-5" onClick={loadMore}>
                <LoadMoreButton />
              </div> */}
            </div>
            <Footer />
          </div>
        </Suspense>
      </div>
    </>
  );
}

export default Videos;
